import React from 'react';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100vw',
        height: '100vh'
    }
}));
function FullScreen({ children }) {
    const classes = useStyles();

    return (
        <Grid container className={classes.root}>
            {children}
        </Grid>
    );
}

export default React.memo(FullScreen);
